import Vue from 'vue'
import { dealWithSpecialValue as DealWithSpecialValue } from './index'

Vue.filter('statusCp', function (input) {
    if (input == 10) {
      return '待发货'
    } else if (input == 20) {
      return '待收货'
    } else if (input == 30) {
      return '待对账'
    } else if (input == 40) {
      return '交易成功'
    } else if (input == 100) {
      return '交易关闭'
    }
  
  })
  
  Vue.filter('statusDt', function (input) {
    if (input == 10) {
      return '买家已下单'
    } else if (input == 30) {
      return '买家待对账'
    } else if (input == 100) {
      return '已完成'
    }
  })
  
  Vue.filter('numFilter', function (input) {
    // 截取当前数据到小数点后两位
    let realVal = parseFloat(input).toFixed(2)
    return realVal
  })

  Vue.filter ('filterLabel', function (val = '', data) {
    const res = DealWithSpecialValue(val)
    if (res === '-') {
      return res
    }
    if (Object.prototype.toString.call(data) == '[object Map]') {
      return data.get(String(val)).label
    } else {
      return data.filter(item => val == item.value)[0].label
    }
  })

   // 销售/采购单位 - 显示
  Vue.filter('filterUnit', (val, val2, unit = '') => {
    if (val === unit && val2 == 1) {
      return `${val}`
    } else {
      return `${val} ( ${val2} ${unit} )`
    }
  })